'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = Icon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaIcon = function FaIcon(_ref) {
  var name = _ref.name,
      className = _ref.className,
      auto = _ref.auto,
      size = _ref.size,
      color = _ref.color,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['name', 'className', 'auto', 'size', 'color']);

  return _react2.default.createElement('i', (0, _extends3.default)({}, rest, {
    className: (0, _classnames2.default)('Icon fa fa-' + name, className),
    style: (0, _extends3.default)({}, !auto && {
      fontSize: size,
      width: size,
      height: size,
      lineHeight: (0, _isString2.default)(size) ? size : size + 'px'
    }, {
      color: color
    })
  }));
};

FaIcon.propTypes = {
  className: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  size: _propTypes2.default.number,
  color: _propTypes2.default.string,
  auto: _propTypes2.default.bool
};

FaIcon.defaultProps = {
  size: 21
};

var RE_MATERIAL_NAME = /\s/g;

var MaterialIcon = function MaterialIcon(_ref2) {
  var name = _ref2.name,
      className = _ref2.className,
      small = _ref2.small,
      medium = _ref2.medium,
      large = _ref2.large,
      color = _ref2.color,
      light = _ref2.light,
      size = _ref2.size,
      rest = (0, _objectWithoutProperties3.default)(_ref2, ['name', 'className', 'small', 'medium', 'large', 'color', 'light', 'size']);
  return _react2.default.createElement(
    'i',
    (0, _extends3.default)({}, rest, {
      className: (0, _classnames2.default)('material-icons', small && 'md-18', medium && 'md-36', large && 'md-48', light && 'md-light', className),
      style: {
        color: color,
        fontSize: size
      }
    }),
    name.replace(RE_MATERIAL_NAME, '_')
  );
};

MaterialIcon.propTypes = {
  className: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  small: _propTypes2.default.bool,
  medium: _propTypes2.default.bool,
  large: _propTypes2.default.bool,
  light: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  size: _propTypes2.default.number
};

/**
 * Icon component, using Font Awesome or Material Icons, depending on the `material` prop.
 */
function Icon(_ref3) {
  var material = _ref3.material,
      props = (0, _objectWithoutProperties3.default)(_ref3, ['material']);

  return material ? _react2.default.createElement(MaterialIcon, props) : _react2.default.createElement(FaIcon, props);
}

Icon.propTypes = {
  material: _propTypes2.default.bool
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/Icon/index.js
// module id = 29
// module chunks = 0